import { POShipProduct } from "./POShipProduct";

export interface UpdatePurchaseOrderParams {
	purchaseOrderID: number,
	validatedShipDate?: Date,
	serviceInitiatedDate?: Date,
	validatedDeliveryDate?: Date,
	GS1128?: string,
	products: POShipProduct[],
	updateType: PurchaseOrderUpdateType
}

export enum PurchaseOrderUpdateType {
	Validate = 1,
	Ship = 2,
	Service = 3,
	ValidateDelivery = 4,
	SubmitDelivery = 5
}
